import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import type { Hint } from './types'
import ReactCardFlip from 'react-card-flip'

const Container = styled(ReactCardFlip)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    height: 4rem;
    gap: 1rem;

    h2 {
        font-size: 1.25rem;
        text-transform: capitalize;
        font-weight: bold;
        margin: 0;
    }
`

const SharedStyles = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    border-radius: 5px;
    padding: 5px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
    height: 3rem;
    width: 8rem;
    font-size: .75rem;

    &:not(:disabled):hover {
        transform: scale(1.05);
    }
     
    &:not(:disabled):hover:active {
        transform: scale(1.05) translateY(.125rem);
    }

    @media (max-width: 768px) {
        height: 2rem;
        width: 6rem;
        font-size: .5rem;
    }

    @media (max-width: 480px) {
        height: 1rem;
        width: 5rem;
        font-size: .35rem;
    }
`

const StyledPrompt = styled.div`
    ${SharedStyles}
    background-color: lightblue;
`

const StyledHint = styled.div`
    ${SharedStyles}
    background-color: white;
`

const HintTile = ({ group, answer }: Hint): JSX.Element => {
  const [isRevealed, setIsRevealed] = useState(false)
  const prompt = `${group.toLocaleUpperCase()}`
  const hint = `${group}: ${answer.replace('-', ' ')}`

  return (
    <Container isFlipped={isRevealed}>
        <StyledPrompt onClick={() => { setIsRevealed(true) }}>
            {prompt}
        </StyledPrompt>
        <StyledHint>
            {hint}
        </StyledHint>
    </Container>
  )
}

export default HintTile
